<template>
  <div class="page-flatpage login-view">
    <main class="main">
      <div class="main-content">
        <breadcrumbs style="visibility: hidden" />

        <article class="">
          <h1 class="font-bold text-2xl">Créez votre compte</h1>
          <div class="rte"></div>
          <form
            @submit.prevent="checkForm"
            ref="form"
            class="flex justify-center"
          >
            <div class="auth-login p-0 mt-6 ">
              <div class="flex md:flex-row flex-col">
                <div class="flex flex-col w-1/2 items-start mb-5 mr-6">
                  <label for="user" class="orange">Prénom et Nom*</label>
                  <span class="justify-start items-start">
                    <input
                      type="text"
                      name="user"
                      id="user"
                      class="py-1 px-2 not-italic w-64"
                      v-model="creationForm.fields.name.value"
                      placeholder="ex. John Doe"
                      required
                    />
                  </span>
                </div>
                <div class="flex flex-col w-1/2 items-start mb-5">
                  <label for="email" class="orange">Adresse email*</label>
                  <span class="">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      class="py-1 px-2 w-64"
                      v-model="creationForm.fields.email.value"
                      required
                      placeholder="Votre adresse email"
                    />
                  </span>
                </div>
              </div>
              <div class="flex md:flex-row flex-col">
                <div class="flex flex-col w-1/2 items-start mb-5 mr-6">
                  <label for="user" class="orange">Pays*</label>
                  <span class="justify-start items-start">
                    <select
                      name="pays"
                      id="pays"
                      class="w-64 py-1 px-2"
                      v-model="creationForm.fields.countries.value"
                      required
                    >
                      <option
                        v-for="country in creationForm.fields.countries.values"
                        :key="country.id"
                        :value="country.id"
                      >
                        {{ country.display_name }}
                      </option>
                    </select>
                  </span>
                </div>

                <div class="flex flex-col w-1/2 items-start mb-5">
                  <label for="email" class="orange">Catégorie*</label>
                  <span class="">
                    <select
                      name="categorie"
                      id="categorie"
                      class="pr-50 w-64 py-1 px-2"
                      v-model="creationForm.fields.categories.value"
                      required
                    >
                      <option
                        v-for="categorie in creationForm.fields.categories
                          .values"
                        :key="categorie.id"
                        :value="categorie.id"
                      >
                        {{ categorie.display_name }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
              <div class="flex mb-12 md:flex-row flex-col">
                <div class="flex flex-col w-1/2 items-start mr-6">
                  <label for="pwd" class="orange">Mot de passe*</label>
                  <span class="">
                    <input
                      type="password"
                      name="pwd"
                      id="pwd"
                      class="w-64 py-1 px-2"
                      v-model="creationForm.fields.password.value"
                      placeholder="Vous seul le connaissez..."
                      required
                    />
                  </span>
                </div>
                <div class="flex flex-col w-1/2 items-start">
                  <label for="pwd" class="orange text-left"
                    >Confirmation de votre mot de passe</label
                  >
                  <input
                    type="password"
                    name="pwd"
                    id="pwd2"
                    class="w-64 py-1 px-2"
                    v-model="creationForm.fields.password2.value"
                    required
                  />
                </div>
              </div>
              <div class="md:w-99 mb-5">
                <input
                  type="checkbox"
                  name="activeSub"
                  id="activeCGU"
                  v-model="creationForm.fields.activeCGU.value"
                  required
                  class=""
                />
                <label for="activeCGU" class="bold text-sm"
                  >En validant, j’accepte les Conditions Générales d'Utilisation
                  du site Index Acta*</label
                >
              </div>

              <!-- <div
                v-if="creationForm.errors.length"
                class="text-center text-red-500 font-bold"
              >
                <ul>
                  <li v-for="(error, i) in creationForm.errors" :key="i">
                    {{ error }}
                  </li>
                </ul>
              </div> -->
              <button
                type="submit"
                class="bg-orange text-white px-8 py-2 mt-14"
                @click="checkForm"
                :disabled="busy"
              >
                {{ busy ? "Chargement..." : "Valider" }}
              </button>
            </div>
          </form>
          <div v-if="creationForm.errors.length" class="text-red-500 font-bold">
            <ul>
              <li
                v-for="(error, i) in creationForm.errors"
                :key="i"
                class="mb-5"
              >
                <div v-html="error"></div>
                <!-- {{ error }} -->
              </li>
            </ul>
          </div>
        </article>
      </div>
    </main>
  </div>
</template>

<script>
import User from "@/api/users.js";
import Authent from "@/api/authent.js";
import Breadcrumbs from "@/components/Breadcrumbs";
import RightBar from "@/components/RightBar.vue";
import SubscriptionIncentiveCard from "@/components/SubscriptionIncentiveCard.vue";

export default {
  name: "Creation",
  components: { Breadcrumbs, RightBar, SubscriptionIncentiveCard },

  data() {
    return {
      activeSubValidate: false,
      trialOffer: false,
      busy: false,
      creationForm: {
        errors: [],
        fields: {
          name: {
            title: "Nom",
            value: null,
          },
          email: {
            title: "Adresse email",
            value: null,
          },
          password: {
            title: "Mot de passe",
            value: null,
          },
          password2: {
            title: "Mot de passe",
            value: null,
          },
          countries: {
            values: [],
            value: null,
          },
          categories: {
            values: [],
            value: null,
          },
          activeCGU: {
            value: false,
          },
          activeSub: {
            value: false,
          },
        },
      },
    };
  },
  async created() {
    // load parameters list
    let params = await Authent.createAccountParameter();
    this.creationForm.fields.countries.values = params.countries;
    this.creationForm.fields.categories.values = params.categories;
  },

  methods: {
    async checkForm() {
      this.creationForm.errors = [];
      if (!this.$refs.form?.checkValidity() || this.busy) return;

      this.busy = true;
      let params = {};
      for (let field in this.creationForm.fields) {
        params[field] = this.creationForm.fields[field].value;
      }
      if (
        this.creationForm.fields.password.value !==
        this.creationForm.fields.password2.value
      ) {
        this.creationForm.errors.push(
          "Les deux mots de passe saisis doivent être identiques."
        );
        this.busy = false;
        return;
      }
      let token = await User.createUser(params)
        .catch((err) => {
          if (err.response.status === 409) {
            this.creationForm.errors.push(
              "Cet utilisateur existe déjà sur acta-editions.com. Pour vous connecter : <br> <ul><li> - saisissez <a href='/connexion' " +
                "style='text-decoration:underline;'>ici</a> le mot de passe associé à ce compte ;</li><li>- ou renouvelez votre mot de passe <a href='/forgot' style='text-decoration:underline'>ici</a>.</li></ul>"
            );
          } else this.creationForm.errors.push("Une erreur est survenue.");
        })
        .finally(() => (this.busy = false));
      if (token && token.hasOwnProperty("refresh")) {
        await this.$store.dispatch("authent/login", { token: token });
        if (this.trialOffer) {
          await User.trialOffer();
          await this.$store.dispatch("authent/updateUser", {});
        }
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>
<style>
.auth-login label {
  text-align: left!important;
  margin-bottom: 0.25rem;
} 
</style>